import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  iconSection: FelaCSS;
  infoSection: FelaCSS;
  infoWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    paddingTop: '8px',
    paddingBottom: '8px',
    backgroundColor: colors.white,
  },

  iconSection: {
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: colors.space15,
  },

  infoSection: {
    flexGrow: 1,
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
  },

  infoWrap: {
    ':not(:last-of-type)': {
      marginBottom: '8px',
    },
  },
});

export default styles;
